/* SparesCzar Product Gallery — arrows, thumbnails, counter */
document.addEventListener('DOMContentLoaded', function() {
  var gallery = document.querySelector('media-gallery');
  var grid = gallery && gallery.querySelector('.media-gallery__grid');
  if (!grid || grid.children.length < 2) return;

  var items = Array.from(grid.children);
  var total = items.length;
  var current = 0;

  // Create overlay wrapper for arrows + counter (sits on top of grid)
  var overlay = document.createElement('div');
  overlay.className = 'scz-gallery-overlay';
  // Insert overlay right after the grid, inside gallery
  grid.parentNode.insertBefore(overlay, grid.nextSibling);

  // Prev arrow
  var prev = document.createElement('button');
  prev.className = 'scz-gallery-nav scz-gallery-nav--prev';
  prev.innerHTML = '&#8249;';
  prev.setAttribute('aria-label', 'Previous image');

  // Next arrow
  var next = document.createElement('button');
  next.className = 'scz-gallery-nav scz-gallery-nav--next';
  next.innerHTML = '&#8250;';
  next.setAttribute('aria-label', 'Next image');

  overlay.appendChild(prev);
  overlay.appendChild(next);

  // Counter badge
  var counter = document.createElement('div');
  counter.className = 'scz-gallery-counter';
  counter.textContent = '1 / ' + total;
  overlay.appendChild(counter);

  // Thumbnail strip
  var strip = document.createElement('ul');
  strip.className = 'scz-thumb-strip';
  items.forEach(function(item, i) {
    var img = item.querySelector('img');
    if (!img) return;
    var li = document.createElement('li');
    if (i === 0) li.classList.add('is-active');
    var thumb = document.createElement('img');
    thumb.src = img.src;
    thumb.alt = img.alt || 'Thumbnail ' + (i + 1);
    thumb.loading = 'lazy';
    li.appendChild(thumb);
    li.addEventListener('click', function() { goTo(i); });
    strip.appendChild(li);
  });
  // Insert thumbnails after the overlay (below the grid)
  overlay.parentNode.insertBefore(strip, overlay.nextSibling);

  function goTo(index) {
    if (index < 0) index = total - 1;
    if (index >= total) index = 0;
    current = index;
    grid.scrollTo({ left: grid.offsetWidth * current, behavior: 'smooth' });
    updateUI();
  }

  function updateUI() {
    counter.textContent = (current + 1) + ' / ' + total;
    var thumbs = strip.querySelectorAll('li');
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].classList.toggle('is-active', i === current);
    }
  }

  prev.addEventListener('click', function() { goTo(current - 1); });
  next.addEventListener('click', function() { goTo(current + 1); });

  // Track scroll to update counter + active thumb
  var scrollTimeout;
  grid.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      var w = grid.offsetWidth;
      if (w > 0) {
        current = Math.round(grid.scrollLeft / w);
        updateUI();
      }
    }, 80);
  });
});
